<template>
	<div :class="cls">
		<el-scrollbar style="height:100%" ref="scrollview">
			<slot></slot>
			<zui-toast v-if="toastText!==''">
				{{toastText}}
			</zui-toast>
			<zui-loading v-if="loadingVisible" />
		</el-scrollbar>
	</div>
</template>
<script>
	import './less/page.css'
	import '../assets/css/vivify.min.css'
	import ZuiToast from './Toast'
	import ZuiLoading from './Loading'
	import Util from '../Util'

	export default {
		props: {
			title: '峨眉'
		},
		components: {
			ZuiToast,
			ZuiLoading
		},
		mounted() {
			let ivue = this;
			// 获取指定元素
			// const scrollview = this.$refs['scrollview']
			const scrollview = ivue.$refs['scrollview'].$refs['wrap'];
			// 添加滚动监听，该滚动监听了拖拽滚动条
			// 尾部的 true 最好加上，我这边测试没加 true ，拖拽滚动条无法监听到滚动，加上则可以监听到拖拽滚动条滚动回调
			// scrollview.addEventListener('scroll', this.scrollChange(), true)
			scrollview.addEventListener('scroll', ivue.scrollChanged, true)
		},
		// beforeDestroy 与 destroyed 里面移除都行
		beforeDestroy() {
			let ivue = this;
			// 获取指定元素
			// const scrollview = this.$refs['scrollview']
			const scrollview = ivue.$refs['scrollview'].$refs['wrap'];
			// 移除监听
			// scrollview.removeEventListener('scroll', this.scrollChange, true)
			scrollview.removeEventListener('scroll', ivue.scrollChanged, true)
		},
		computed: {
			cls() {
				const cls = (Util.os().android || Util.os().iPhone|| Util.os().harmony) ? 'mobileClass' : 'min-1200'
				return 'zui-page ' + cls
			},
			toastText() {
				// return this.$store.state.toastText
				return ''
			},
			loadingVisible() {
				return false
			},
		},
		methods: {
			// 滚动监听
			scrollChange(e) {
				var index = 0
				if (e && e.pageY > 3200) {
					index = 4
				} else if (e && e.pageY > 2400) {
					index = 3
				} else if (e && e.pageY > 1600) {
					index = 2
				} else if (e && e.pageY > 800) {
					index = 1
				}
				this.$emit('scrollChange', index, e);
			},
			scrollChanged() {
				let ivue = this;
				let height = ivue.$refs['scrollview'].$refs['wrap'].scrollTop;
				this.$emit('scrollChange', height);
			},
			
			
		}
	}
</script>
<style type="text/css">
	.el-scrollbar__wrap {
		overflow-x: hidden;
	}

	.el-scrollbar__bar.is-horizontal {
		display: none;
	}
</style>


// WEBPACK FOOTER //
// src/components/Page.vue